/* eslint-disable react-hooks/exhaustive-deps */
import { useContext, useEffect, useRef, useState } from "react";
import "./tasks.css";
import TaskList from "../../components/taskList/taskList";
import TaskBoards from "../../components/taskBoards/taskBoards";
import Cookies from "js-cookie";
import { CREATE_TASK_URL, TASK_LIST_URL, USERLIST_URL } from "../../global/API";
import EventCalendar from "../../components/eventCalendar/eventCalendar";
import { events } from "../../global/API";
import CustomModal from "../../components/customModal/customModal";
import { Image } from "primereact/image";
import { Calendar } from "primereact/calendar";
import { Editor } from "primereact/editor";
import { formatDateTimeNew } from "../../components/globalFunctions/globalFunctions";
import { Dropdown } from "primereact/dropdown";
import { Accordion, AccordionTab } from "primereact/accordion";
import { AuthContext } from "../../context/AuthContext/AuthContext";

const customModules = {
  toolbar: [["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"]],
  // toolbar: [[{ header: [1, 2, 3, false] }], ["bold", "italic", "underline"], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"], ["clean"]],
};
const customLargeModules = {
  toolbar: [["bold", "italic", "underline"], [{ color: [] }, { background: [] }], [{ list: "ordered" }, { list: "bullet" }], [{ align: [] }], ["link", "image"], ["clean"]],
};

const riskList = [
  { name: "Low", code: "Low" },
  { name: "Medium", code: "Medium" },
  { name: "High", code: "High" },
];
const priorityList = [
  { name: 1, code: "Low" },
  { name: 2, code: "Medium" },
  { name: 3, code: "High" },
];
const Tasks = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [taskList, setTaskList] = useState([]);
  const [taskView, setTaskView] = useState("List");
  const [modifiedTaskDetails, setModifiedTaskDetails] = useState({});
  const [getModalLayout, setGetModalLayout] = useState(null);
  const [activityTab, setActivityTab] = useState(null);
  const [viewTask, setViewTask] = useState([]);
  const [activeEditor, setActiveEditor] = useState(false);
  const [showSubtaskFormFor, setShowSubtaskFormFor] = useState(null);
  const [modalSubtaskDetails, setModalSubtaskDetails] = useState({ title: "" });
  const [text, setText] = useState("");
  const [activeTab, setActiveTab] = useState("task"); // "task" | "subtask"
  const [activeSubtaskId, setActiveSubtaskId] = useState(null);

  // Static states
  const [selectedUser, setSelectedUser] = useState(null);
  const [riskData, setRiskData] = useState(null);
  const [priorityData, setPriorityData] = useState(null);
  const [userList, setUserList] = useState([]);
  const { user } = useContext(AuthContext);

  const [editingTitle, setEditingTitle] = useState(null);
  // const [activeEditorState, setActiveEditorState] = useState(null);
  const [activeEditorState, setActiveEditorState] = useState(null);

  // ref for focusing the input and preventing save when clicking Cancel
  const subtaskInputRef = useRef(null);
  const isCancellingRef = useRef(false);
  const editorRef = useRef(null);
  const editorInitializedRef = useRef(false);

  const getData = async (status = null, page = 1) => {
    const jwtToken = Cookies.get("jwtToken");
    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?limit=100&page=${page}${status ? "&task_status=" + status : ""}`;

    const URL = TASK_LIST_URL + query;

    try {
      const response = await fetch(URL, options);
      if (response.ok) {
        const data = await response.json();
        return data;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    const statusList = await getData();
    const updatedStatusList = statusList.task_status_list.map((eachStatus, idx) => ({ ...eachStatus, order: idx }));
    const totalData = {};
    const statusData = await Promise.all(
      statusList?.task_status_list.map(async (item) => {
        totalData[item?.task_status.replace(/\s+/g, "")] = await getData(item?.task_status);
      }),
    );
    setTaskList(() => ({ statusList: updatedStatusList, ...totalData }));

    setIsLoading(false);
  };

  const fetchAssignedToData = async () => {
    // if (user?.role !== 1) return;
    const jwtToken = Cookies.get("jwtToken");

    const options = {
      method: "GET",
      headers: { Authorization: `Bearer ${jwtToken}`, Accept: "application/json" },
    };

    let query = `?status=1`;
    const URL = USERLIST_URL;
    try {
      const response = await fetch(URL, options);
      const data = await response.json();
      if (data.status === "Success") {
        setUserList(data.data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const refreshTasks = async () => {
    await fetchData();
  };

  const getStatusIcon = (status) => {
    switch ((status || "").toLowerCase()) {
      case "todo":
        return "ri-donut-chart-fill";
      case "completed":
        return "fa fa-check-circle";
      case "in progress":
        return "fa fa-adjust";
      default:
        return "ri-donut-chart-fill"; // fallback
    }
  };

  const updateTaskInline = async ({ id, payload }) => {
    try {
      const jwtToken = Cookies.get("jwtToken");

      const formData = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value);
      });

      const resp = await fetch(CREATE_TASK_URL + id, {
        method: "POST", // or PUT if backend supports
        body: formData,
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Accept: "application/json",
        },
      });

      const data = await resp.json();
      return data;
    } catch (err) {
      console.error("Update failed", err);
    }
  };

  const updateViewTaskState = (taskId, subtaskId, updates) => {
    setViewTask((prev) =>
      prev.map((task) => {
        if (task.id !== taskId) return task;

        // Update MAIN TASK
        if (!subtaskId) {
          return { ...task, ...updates };
        }

        // Update SUBTASK
        return {
          ...task,
          sub_tasks: task.sub_tasks.map((st) => (st.id === subtaskId ? { ...st, ...updates } : st)),
        };
      }),
    );
  };

  const saveTitle = async () => {
    if (!editingTitle) return;

    const { type, taskId, subtaskId, value } = editingTitle;
    const trimmed = value.trim();

    if (!trimmed) {
      setEditingTitle(null);
      return;
    }

    // ✅ Optimistic UI update
    updateViewTaskState(taskId, subtaskId, { title: trimmed });

    // ✅ API call
    await updateTaskInline({
      id: subtaskId || taskId,
      payload: {
        title: trimmed,
        ...(subtaskId ? { parent: taskId } : {}),
      },
    });

    refreshTasks();
    setEditingTitle(null);
  };

  const saveActiveEditor = async () => {
    if (!activeEditorState) return;

    const { entity, section, taskId, subtaskId, value } = activeEditorState;
    const cleaned = value?.trim() || "";

    // optimistic UI
    updateViewTaskState(taskId, subtaskId, {
      [section]: cleaned,
    });

    await updateTaskInline({
      id: subtaskId || taskId,
      payload: {
        [section]: cleaned,
        ...(subtaskId ? { parent: taskId } : {}),
      },
    });

    refreshTasks();
    setActiveEditorState(null);
  };

  const handleEditorCancel = () => {
    // if (!activeEditorState) return;

    // const { taskId, subtaskId, section, originalValue } = activeEditorState;

    // Restore original content in UI
    // updateViewTaskState(taskId, subtaskId, {
    //   [section]: originalValue,
    // });

    setActiveEditorState(null); // CLOSE editor
  };

  const handleModalSubtaskSave = async (parentTask) => {
    const title = (modalSubtaskDetails.title || "").trim();
    if (!title) {
      setShowSubtaskFormFor(null);
      setModalSubtaskDetails({ title: "" });
      return;
    }

    // optimistic object (temp id)
    const tempId = `temp-${Date.now()}`;
    const optimisticObj = {
      id: tempId,
      title,
      task_status: parentTask.task_status || "", // ensure status exists
      assignee: 0,
    };

    // insert optimistically into viewTask
    setViewTask((prev) =>
      prev.map((t) => {
        if (String(t.id) === String(parentTask.id)) {
          const existing = Array.isArray(t.sub_tasks) ? [...t.sub_tasks] : [];
          return { ...t, sub_tasks: [...existing, optimisticObj] };
        }
        return t;
      }),
    );

    // clear UI quickly
    setShowSubtaskFormFor(null);
    setModalSubtaskDetails({ title: "" });

    // build request
    const formData = new FormData();
    formData.append("title", title);
    formData.append("parent", parentTask.id);
    formData.append("assignee", 0);
    formData.append("task_status", parentTask.task_status || "");

    try {
      const jwtToken = Cookies.get("jwtToken");
      const resp = await fetch(CREATE_TASK_URL + 0, {
        method: "POST",
        body: formData,
        headers: {
          Authorization: `Bearer ${jwtToken}`,
          Accept: "application/json",
        },
      });

      const data = await resp.json();

      if (data && data.status === "Success") {
        // server object — adjust according to your API
        const serverObj = data.data || data.task || (data.id ? { id: data.id, title: data.title || title } : null);

        // ensure serverObj has task_status (use parent fallback)
        if (serverObj) {
          serverObj.task_status = serverObj.task_status || parentTask.task_status || "";
        }

        // replace the optimistic item with serverObj (if present)
        setViewTask((prev) =>
          prev.map((t) => {
            if (String(t.id) === String(parentTask.id)) {
              const existing = Array.isArray(t.sub_tasks) ? [...t.sub_tasks] : [];
              const replaced = existing.map((s) => (String(s.id) === String(tempId) ? serverObj || { ...s, id: serverObj?.id || s.id } : s));
              return { ...t, sub_tasks: replaced };
            }
            return t;
          }),
        );

        // optional: refresh canonical list
        refreshTasks && refreshTasks();
      } else {
        console.error("Create subtask failed", data);
        // remove optimistic item or keep and mark failed (here we remove it)
        setViewTask((prev) =>
          prev.map((t) => {
            if (String(t.id) === String(parentTask.id)) {
              const existing = Array.isArray(t.sub_tasks) ? t.sub_tasks.filter((s) => String(s.id) !== String(tempId)) : [];
              return { ...t, sub_tasks: existing };
            }
            return t;
          }),
        );
        // optionally show toast/error to user
      }
    } catch (err) {
      console.error("Error creating subtask:", err);
      // remove optimistic item on network error
      setViewTask((prev) =>
        prev.map((t) => {
          if (String(t.id) === String(parentTask.id)) {
            const existing = Array.isArray(t.sub_tasks) ? t.sub_tasks.filter((s) => String(s.id) !== String(tempId)) : [];
            return { ...t, sub_tasks: existing };
          }
          return t;
        }),
      );
      // optionally show toast/error to user
    }
  };

  useEffect(() => {
    refreshTasks();
  }, [modifiedTaskDetails]);

  useEffect(() => {
    fetchAssignedToData();
  }, []);

  useEffect(() => {
    if (showSubtaskFormFor && subtaskInputRef.current) {
      setTimeout(() => subtaskInputRef.current.focus(), 30);
    }
  }, [showSubtaskFormFor]);

  useEffect(() => {
    if (!activeEditorState) return;

    editorInitializedRef.current = false;

    const timer = setTimeout(() => {
      const quill = editorRef.current?.getQuill();
      if (quill && !editorInitializedRef.current) {
        quill.setContents([]);
        quill.clipboard.dangerouslyPasteHTML(activeEditorState.value || "");
        editorInitializedRef.current = true; // ✅ lock it
      }
    }, 0);

    return () => clearTimeout(timer);
  }, [activeEditorState?.taskId, activeEditorState?.subtaskId, activeEditorState?.section]);

  const onClickTaskDetail = (task) => {
    if (!task) return;

    const isSubtask = task.parent && task.parent !== 0;
    const parentTaskId = isSubtask ? task.parent : task.id;

    // Always open modal with PARENT task only
    let parentTask = viewTask.find((t) => t.id === parentTaskId);

    if (!parentTask) {
      parentTask = isSubtask ? taskList?.statusList?.flatMap((s) => taskList[s.task_status.replace(/\s+/g, "")]?.data || [])?.find((t) => t.id === parentTaskId) : task;

      if (!parentTask) return;

      setViewTask((prev) => [...prev, parentTask]);
    }

    if (isSubtask) {
      setActiveTab("subtask");
      setActiveSubtaskId(task.id);
    } else {
      setActiveTab("task");
      setActiveSubtaskId(null);
    }
  };

  // const onClickTaskDetail = (task, id) => {
  //   const modifiedData = viewTask.filter((lead) => lead.id === id);
  //   if (modifiedData.length === 0) {
  //     setViewTask((prevState) => [...prevState, task]);
  //   }
  // };

  const renderTaskDetails = (item) => {
    const { id, title, dueDate, task_status, parent, description, acceptance_criteria, sub_tasks = [] } = item;
    const isSubtask = !!item.parent;

    const renderTaskDetailLayout = () => {
      return (
        <div className="tab-content tasks-tab">
          {activeTab === "task" && (
            <div className="tab-pane active" id="task-data" role="tabpanel" aria-labelledby="task-data-tab" tabIndex="0">
              <div className="task-parent-title">
                <i className="ri-pencil-line"></i>
                {editingTitle?.type === "task" && editingTitle.taskId === id ? (
                  <input
                    autoFocus
                    className="form-control"
                    value={editingTitle.value}
                    onChange={(e) => setEditingTitle((p) => ({ ...p, value: e.target.value }))}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") saveTitle();
                      if (e.key === "Escape") setEditingTitle(null);
                    }}
                    onBlur={saveTitle}
                  />
                ) : (
                  <h3
                    className="editable-title"
                    onClick={() =>
                      setEditingTitle({
                        type: "task",
                        taskId: id,
                        value: title,
                      })
                    }
                  >
                    {title}
                  </h3>
                )}
              </div>
              <form className="custom-editable-form">
                <div className="form-group-grid">
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-creative-commons-sa-line"></i> Status
                    </label>
                    <Dropdown
                      value={task_status}
                      options={taskList?.statusList || []}
                      optionLabel="task_status"
                      optionValue="task_status"
                      appendTo="self"
                      className="customised-dropdown"
                      onChange={async (e) => {
                        const newStatus = e.value;
                        updateViewTaskState(id, null, { task_status: newStatus });
                        await updateTaskInline({
                          id,
                          payload: { task_status: newStatus },
                        });
                        refreshTasks();
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-user-line"></i> Assignees
                    </label>
                    <Dropdown
                      value={item.assignee || null}
                      options={userList.filter((u) => u.role !== 1)}
                      optionLabel="name"
                      optionValue="id"
                      placeholder="Select Assignee"
                      filter
                      appendTo="self"
                      className="customised-dropdown"
                      onChange={async (e) => {
                        const newAssignee = e.value || null;

                        // Optimistic UI
                        updateViewTaskState(id, null, { assignee: newAssignee });

                        // API Save
                        await updateTaskInline({
                          id,
                          payload: { assignee: newAssignee },
                        });

                        refreshTasks();
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-calendar-2-fill"></i> Dates
                    </label>
                    <Calendar
                      value={dueDate ? new Date(dueDate) : null}
                      showIcon
                      dateFormat="M dd, yy"
                      showButtonBar
                      onChange={async (e) => {
                        const newDate = e.value;

                        updateViewTaskState(id, null, { dueDate: newDate });

                        await updateTaskInline({
                          id,
                          payload: { dueDate: newDate.toISOString() },
                        });

                        refreshTasks();
                      }}
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i className="ri-arrow-up-down-fill"></i> Relationships
                    </label>
                    <input type="text" className="form-control" placeholder="Empty" />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i class="ri-flag-2-line"></i> Risk
                    </label>
                    <Dropdown
                      value={selectedUser}
                      onChange={(e) => setSelectedUser(e.value)}
                      options={riskList}
                      optionLabel="name"
                      optionValue="code"
                      placeholder="Select Assignee"
                      appendTo="self"
                      className="customised-dropdown"
                    />
                  </div>
                  <div className="form-group">
                    <label className="form-label">
                      <i class="ri-error-warning-line"></i> Priority
                    </label>
                    <Dropdown
                      value={selectedUser}
                      onChange={(e) => setSelectedUser(e.value)}
                      options={priorityList}
                      optionLabel="name"
                      optionValue="code"
                      placeholder="Select Assignee"
                      appendTo="self"
                      className="customised-dropdown"
                    />
                  </div>
                </div>
                <Accordion multiple activeIndex={[0]}>
                  <AccordionTab
                    header={
                      <label className="form-label form-label-large">
                        <i className="ri-align-left"></i> &nbsp; Description
                      </label>
                    }
                  >
                    <div className="form-group">
                      {activeEditorState?.section === "description" && activeEditorState?.entity === "task" && activeEditorState?.taskId === id ? (
                        <div className="editor-wrapper">
                          <Editor
                            ref={editorRef}
                            // value={activeEditorState.value}
                            modules={customLargeModules}
                            className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                            onTextChange={(e) =>
                              setActiveEditorState((prev) => ({
                                ...prev,
                                value: e.htmlValue,
                              }))
                            }
                            // onBlur={saveActiveEditor}
                            placeholder={description ? "" : "Click to add description..."}
                            onKeyDown={(e) => {
                              if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                            }}
                          />

                          <div className="editor-actions">
                            <button type="button" className="btn btn-sm " onClick={saveActiveEditor}>
                              <i className="ri-check-line"></i>
                            </button>
                            <button type="button" className="btn btn-sm " onClick={() => setActiveEditorState(null)}>
                              {/* onClick={handleEditorCancel} */}
                              <i className="ri-close-line"></i>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="task-description-preview"
                          onClick={() =>
                            setActiveEditorState({
                              entity: "task",
                              section: "description",
                              taskId: id,
                              value: description || "",
                            })
                          }
                          dangerouslySetInnerHTML={{
                            __html: description || "<i>Click to add description</i>",
                          }}
                        />
                      )}

                      {/* {activeEditorState?.type === "task" && activeEditorState.taskId === id ? (
                        <Editor
                          value={activeEditorState.value}
                          className="texteditor editor-bottom-toolbar"
                          onTextChange={(e) => setActiveEditorState((p) => ({ ...p, value: e.htmlValue }))}
                          onBlur={saveDescription}
                          onKeyDown={(e) => {
                            if (e.ctrlKey && e.key === "Enter") saveDescription();
                          }}
                        />
                      ) : (
                        <div
                          className="task-description-preview"
                          onClick={() =>
                            setActiveEditorState({
                              type: "task",
                              taskId: id,
                              value: description || "",
                            })
                          }
                          dangerouslySetInnerHTML={{ __html: description || "<i>Click to add description</i>" }}
                        ></div>
                      )} */}
                    </div>
                  </AccordionTab>
                  <AccordionTab
                    header={
                      <label className="form-label form-label-large">
                        <i class="ri-file-search-line"></i> &nbsp; Acceptance Criteria
                      </label>
                    }
                  >
                    <div className="form-group">
                      {activeEditorState?.section === "acceptance_criteria" && activeEditorState?.entity === "task" && activeEditorState?.taskId === id ? (
                        <div className="editor-wrapper">
                          <Editor
                            ref={editorRef}
                            modules={customLargeModules}
                            className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                            onTextChange={(e) =>
                              setActiveEditorState((prev) => ({
                                ...prev,
                                value: e.htmlValue,
                              }))
                            }
                            placeholder={acceptance_criteria ? "" : "Click here to add text..."}
                            onKeyDown={(e) => {
                              if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                            }}
                          />
                          <div className="editor-actions">
                            <button type="button" className="btn btn-sm " onClick={saveActiveEditor}>
                              <i className="ri-check-line"></i>
                            </button>
                            <button type="button" className="btn btn-sm " onClick={handleEditorCancel}>
                              <i className="ri-close-line"></i>
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div
                          className="task-description-preview"
                          onClick={() =>
                            setActiveEditorState({
                              entity: "task",
                              section: "acceptance_criteria",
                              taskId: id,
                              value: item.acceptance_criteria || "",
                            })
                          }
                          dangerouslySetInnerHTML={{
                            __html: item.acceptance_criteria || "<i>Click here to add text..</i>",
                          }}
                        />
                      )}

                      {/* {activeEditorState?.type === "task" && activeEditorState.taskId === id ? (
                        <Editor
                          value={activeEditorState.value}
                          className="texteditor editor-bottom-toolbar"
                          onTextChange={(e) => setActiveEditorState((p) => ({ ...p, value: e.htmlValue }))}
                          onBlur={saveDescription}
                          onKeyDown={(e) => {
                            if (e.ctrlKey && e.key === "Enter") saveDescription();
                          }}
                        />
                      ) : (
                        <div className="task-description-preview">
                          <p>
                            Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard
                            McClintock, a Latin professor at Hampden-Sydney College in Virginia.
                          </p>
                          <ul>
                            <li>Contrary to popular belief, Lorem Ipsum is not simply random text</li>
                          </ul>
                        </div>
                      )} */}
                    </div>
                  </AccordionTab>
                  <AccordionTab
                    header={
                      <label className="form-label form-label-large">
                        <i class="ri-chat-thread-line"></i> &nbsp;Discussion
                      </label>
                    }
                  >
                    <div className="task-discussion">
                      <div className="form-group">
                        {activeEditorState?.section === "discussion" && activeEditorState?.entity === "task" && activeEditorState?.taskId === id ? (
                          <div className="editor-wrapper">
                            <Editor
                              ref={editorRef}
                              modules={customLargeModules}
                              className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                              onTextChange={(e) => setActiveEditorState((p) => ({ ...p, value: e.htmlValue }))}
                              onKeyDown={(e) => {
                                if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                              }}
                            />

                            <div className="editor-actions">
                              <button type="button" className="btn btn-sm ">
                                <i className="ri-check-line"></i>
                              </button>
                              <button type="button" className="btn btn-sm " onClick={handleEditorCancel}>
                                <i className="ri-close-line"></i>
                              </button>
                            </div>
                          </div>
                        ) : (
                          <div
                            className="task-view-card discussion-card"
                            onClick={() =>
                              setActiveEditorState({
                                entity: "task",
                                section: "discussion",
                                taskId: id,
                                value: "",
                              })
                            }
                          >
                            <div className="discussion-content discussion-content-new-comment">
                              <span>RK</span>
                              <textarea className="form-control" placeholder="Write a comment..." rows={3}></textarea>
                            </div>
                          </div>
                        )}

                        {/* {activeEditorState?.type === "task" && activeEditorState.taskId === id ? (
                          <Editor
                            value={activeEditorState.value}
                            className="texteditor"
                            onTextChange={(e) => setActiveEditorState((p) => ({ ...p, value: e.htmlValue }))}
                            onBlur={saveDescription}
                            onKeyDown={(e) => {
                              if (e.ctrlKey && e.key === "Enter") saveDescription();
                            }}
                          />
                        ) : (
                          <div className="task-view-card discussion-card">
                            <div className="discussion-content discussion-content-new-comment">
                              <span>RK</span>
                              <textarea className="form-control" placeholder="Write a comment..." rows={3}></textarea>
                            </div>
                          </div>
                        )} */}
                      </div>

                      <div className="task-view-card discussion-card">
                        <div className="discussion-header">
                          <h5>
                            <i>RK</i>
                            Ramesh Kuppili
                            <span>Commented on 20 dec 2025</span>
                          </h5>
                        </div>
                        <div className="discussion-content">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint
                            occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et
                            expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                          </p>
                        </div>
                      </div>
                      <div className="task-view-card discussion-card">
                        <div className="discussion-header">
                          <h5>
                            <i>RK</i>
                            Ramesh Kuppili
                            <span>Commented on 20 dec 2025</span>
                          </h5>
                        </div>
                        <div className="discussion-content">
                          <p>
                            At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint
                            occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et
                            expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                          </p>
                        </div>
                      </div>
                    </div>
                  </AccordionTab>
                </Accordion>
              </form>
            </div>
          )}
          {activeTab === "subtask" &&
            sub_tasks.map((eachSubtask) =>
              eachSubtask.id === activeSubtaskId ? (
                <div key={eachSubtask.id} className="tab-pane active">
                  <div className="subtask-header">
                    <span>Subtask of</span>
                    <i className={getStatusIcon(task_status)} style={{ marginRight: 8 }}></i>
                    {/* <i className="ri-circle-line" style={{ marginRight: 8 }}></i> */}
                    <h5>{title}</h5>
                  </div>

                  <div className="task-parent-title task-child-title">
                    <i className="ri-git-merge-line"></i>
                    <i className="ri-pencil-line"></i>
                    {editingTitle?.type === "subtask" && editingTitle.subtaskId === eachSubtask.id ? (
                      <input
                        autoFocus
                        className="form-control"
                        value={editingTitle.value}
                        onChange={(e) => setEditingTitle((p) => ({ ...p, value: e.target.value }))}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") saveTitle();
                          if (e.key === "Escape") setEditingTitle(null);
                        }}
                        onBlur={saveTitle}
                      />
                    ) : (
                      <h3
                        className="editable-title"
                        onClick={() =>
                          setEditingTitle({
                            type: "subtask",
                            taskId: id,
                            subtaskId: eachSubtask.id,
                            value: eachSubtask.title,
                          })
                        }
                      >
                        {eachSubtask.title}
                      </h3>
                    )}
                  </div>
                  <form className="custom-editable-form">
                    <div className="form-group-grid">
                      <div className="form-group">
                        <label className="form-label">
                          <i className="ri-creative-commons-sa-line"></i> Status
                        </label>
                        <Dropdown
                          value={eachSubtask.task_status}
                          options={taskList?.statusList || []}
                          optionLabel="task_status"
                          optionValue="task_status"
                          appendTo="self"
                          className="customised-dropdown"
                          onChange={async (e) => {
                            const newStatus = e.value;
                            // Optimistic UI
                            updateViewTaskState(id, eachSubtask.id, {
                              task_status: newStatus,
                            });
                            // API call
                            await updateTaskInline({
                              id: eachSubtask.id,
                              payload: {
                                task_status: newStatus,
                                parent: id,
                              },
                            });

                            refreshTasks();
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          <i className="ri-user-line"></i> Assignees
                        </label>

                        <Dropdown
                          value={eachSubtask.assignee || null}
                          options={userList.filter((u) => u.role !== 1)}
                          optionLabel="name"
                          optionValue="id"
                          placeholder="Select Assignee"
                          filter
                          appendTo="self"
                          className="customised-dropdown"
                          onChange={async (e) => {
                            const newAssignee = e.value;

                            // Optimistic UI
                            updateViewTaskState(id, eachSubtask.id, { assignee: newAssignee });

                            // API call
                            await updateTaskInline({
                              id: eachSubtask.id,
                              payload: {
                                assignee: newAssignee,
                                parent: id,
                              },
                            });

                            refreshTasks();
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          <i className="ri-calendar-2-fill"></i> Dates
                        </label>
                        <Calendar
                          value={eachSubtask.dueDate ? new Date(eachSubtask.dueDate) : null}
                          showIcon
                          dateFormat="M dd, yy"
                          showButtonBar
                          onChange={async (e) => {
                            const newDate = e.value;

                            updateViewTaskState(id, eachSubtask.id, {
                              dueDate: newDate,
                            });

                            await updateTaskInline({
                              id: eachSubtask.id,
                              payload: {
                                dueDate: newDate.toISOString(),
                                parent: id,
                              },
                            });

                            refreshTasks();
                          }}
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          <i className="ri-arrow-up-down-fill"></i> Relationships
                        </label>
                        <input type="text" className="form-control" placeholder="Empty" />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          <i class="ri-flag-2-line"></i> Risk
                        </label>
                        <Dropdown
                          value={selectedUser}
                          onChange={(e) => setSelectedUser(e.value)}
                          options={riskList}
                          optionLabel="name"
                          optionValue="code"
                          placeholder="Select Assignee"
                          appendTo="self"
                          className="customised-dropdown"
                        />
                      </div>
                      <div className="form-group">
                        <label className="form-label">
                          <i class="ri-error-warning-line"></i> Priority
                        </label>
                        <Dropdown
                          value={selectedUser}
                          onChange={(e) => setSelectedUser(e.value)}
                          options={priorityList}
                          optionLabel="name"
                          optionValue="code"
                          placeholder="Select Assignee"
                          appendTo="self"
                          className="customised-dropdown"
                        />
                      </div>
                    </div>
                    <Accordion multiple activeIndex={[0]}>
                      <AccordionTab
                        header={
                          <label className="form-label">
                            <i className="ri-align-left"></i> &nbsp; Description
                          </label>
                        }
                      >
                        <div className="form-group">
                          {activeEditorState?.section === "description" && activeEditorState?.entity === "subtask" && activeEditorState?.subtaskId === eachSubtask.id ? (
                            <div className="editor-wrapper">
                              <Editor
                                ref={editorRef}
                                modules={customLargeModules}
                                className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                                onTextChange={(e) =>
                                  setActiveEditorState((prev) => ({
                                    ...prev,
                                    value: e.htmlValue,
                                  }))
                                }
                                placeholder={description ? "" : "Click to add description..."}
                                onKeyDown={(e) => {
                                  if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                                }}
                              />
                              <div className="editor-actions">
                                <button type="button" className="btn btn-sm " onClick={saveActiveEditor}>
                                  <i className="ri-check-line"></i>
                                </button>
                                <button type="button" className="btn btn-sm " onClick={() => setActiveEditorState(null)}>
                                  <i className="ri-close-line"></i>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="task-description-preview"
                              onClick={() =>
                                setActiveEditorState({
                                  entity: "subtask",
                                  section: "description",
                                  taskId: id,
                                  subtaskId: eachSubtask.id,
                                  value: eachSubtask.description || "",
                                })
                              }
                              dangerouslySetInnerHTML={{
                                __html: eachSubtask.description || "<i>Click to add description</i>",
                              }}
                            />
                          )}
                        </div>
                      </AccordionTab>
                      <AccordionTab
                        header={
                          <label className="form-label">
                            <i class="ri-file-search-line"></i> &nbsp; Acceptance Criteria
                          </label>
                        }
                      >
                        <div className="form-group">
                          {activeEditorState?.section === "acceptance_criteria" && activeEditorState?.entity === "subtask" && activeEditorState?.subtaskId === eachSubtask.id ? (
                            <div className="editor-wrapper">
                              <Editor
                                ref={editorRef}
                                modules={customLargeModules}
                                className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                                onTextChange={(e) =>
                                  setActiveEditorState((prev) => ({
                                    ...prev,
                                    value: e.htmlValue,
                                  }))
                                }
                                placeholder={acceptance_criteria ? "" : "Click here to add text..."}
                                onKeyDown={(e) => {
                                  if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                                }}
                              />
                              <div className="editor-actions">
                                <button type="button" className="btn btn-sm " onClick={saveActiveEditor}>
                                  <i className="ri-check-line"></i>
                                </button>
                                <button type="button" className="btn btn-sm " onClick={() => setActiveEditorState(null)}>
                                  <i className="ri-close-line"></i>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <div
                              className="task-description-preview"
                              onClick={() =>
                                setActiveEditorState({
                                  entity: "subtask",
                                  section: "acceptance_criteria",
                                  taskId: id,
                                  subtaskId: eachSubtask.id,
                                  value: eachSubtask.acceptance_criteria || "",
                                })
                              }
                              dangerouslySetInnerHTML={{
                                __html: eachSubtask.acceptance_criteria || "<i>Click here to add text..</i>",
                              }}
                            />
                          )}
                        </div>
                      </AccordionTab>
                      <AccordionTab
                        header={
                          <label className="form-label">
                            <i class="ri-chat-thread-line"></i> &nbsp;Discussion
                          </label>
                        }
                      >
                        <div className="task-discussion">
                          <div className="form-group">
                            {activeEditorState?.section === "discussion" && activeEditorState?.entity === "subtask" && activeEditorState?.taskId === id ? (
                              <div className="editor-wrapper">
                                <Editor
                                  ref={editorRef}
                                  modules={customLargeModules}
                                  className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                                  onTextChange={(e) => setActiveEditorState((p) => ({ ...p, value: e.htmlValue }))}
                                  onKeyDown={(e) => {
                                    if (e.ctrlKey && e.key === "Enter") saveActiveEditor();
                                  }}
                                />

                                <div className="editor-actions">
                                  <button type="button" className="btn btn-sm ">
                                    <i className="ri-check-line"></i>
                                  </button>
                                  <button type="button" className="btn btn-sm " onClick={handleEditorCancel}>
                                    <i className="ri-close-line"></i>
                                  </button>
                                </div>
                              </div>
                            ) : (
                              <div
                                className="task-view-card discussion-card"
                                onClick={() =>
                                  setActiveEditorState({
                                    entity: "subtask",
                                    section: "discussion",
                                    taskId: id,
                                    subtaskId: eachSubtask.id,
                                    value: eachSubtask.discussion || "",
                                  })
                                }
                              >
                                <div className="discussion-content discussion-content-new-comment">
                                  <span>RK</span>
                                  <textarea className="form-control" placeholder="Write a comment..." rows={3}></textarea>
                                </div>
                              </div>
                            )}
                          </div>
                          <div className="task-view-card discussion-card">
                            <div className="discussion-header">
                              <h5>
                                <i>RK</i>
                                Ramesh Kuppili
                                <span>Commented on 20 dec 2025</span>
                              </h5>
                            </div>
                            <div className="discussion-content">
                              <p>
                                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint
                                occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et
                                expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                              </p>
                            </div>
                          </div>
                          <div className="task-view-card discussion-card">
                            <div className="discussion-header">
                              <h5>
                                <i>RK</i>
                                Ramesh Kuppili
                                <span>Commented on 20 dec 2025</span>
                              </h5>
                            </div>
                            <div className="discussion-content">
                              <p>
                                At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint
                                occaecati cupiditate non provident, similique sunt in culpa qui officia deserunt mollitia animi, id est laborum et dolorum fuga. Et harum quidem rerum facilis est et
                                expedita distinctio. Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus.
                              </p>
                            </div>
                          </div>
                        </div>
                      </AccordionTab>
                    </Accordion>

                    {/* <div className="form-group mb-3 mt-2">
                      <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} className="texteditor" />
                    </div> */}
                    {/* <div className="subtasks-list" role="tablist">
                      <button className="nav-link active" id={`${activeSubtaskId}-custom-tab`} data-bs-toggle="pill" data-bs-target={`#${activeSubtaskId}-custom`} type="button" role="tab">
                        Custom Fields
                      </button>
                      <button className="nav-link" id={`${activeSubtaskId}-attachment-tab`} data-bs-toggle="pill" data-bs-target={`#${activeSubtaskId}-attachment`} type="button" role="tab">
                        Attachments
                      </button>
                    </div>
                    <div className="tab-content">
                      <div className="tab-pane fade show active" id={`${activeSubtaskId}-custom`} role="tabpanel" aria-labelledby={`${activeSubtaskId}-custom-tab`}>
                        <ul className="custom-field-list">
                          <li>
                            <i className="ri-text"></i> {eachSubtask.title}
                          </li>
                          <li>
                            <i className="ri-phone-line"></i> Phone
                          </li>
                          <li>
                            <i className="ri-mail-line"></i> Email
                          </li>
                          <li>
                            <i className="ri-global-line"></i> Website
                          </li>
                        </ul>
                        <button className="custom-field-add-btn">
                          <i className="ri-add-line"></i> Create Custom Fields
                        </button>
                      </div>
                      <div className="tab-pane fade" id={`${activeSubtaskId}-attachment`} role="tabpanel" aria-labelledby={`${activeSubtaskId}-attachment-tab`}>
                        <div className="attachment-gallery">
                          <div className="attachment-gallery-item">
                            <figure>
                              <Image src="./assets/images/customer-bg.jpg" alt="Image" preview />
                            </figure>
                            <div className="content">
                              <p>Jul 10 at 10:00 am</p>
                              <span>{eachSubtask.title}</span>
                              <span className="attachment-agent-name">RK</span>
                            </div>
                          </div>
                          <div className="attachment-gallery-item">
                            <figure>
                              <Image src="./assets/images/agent-1.png" alt="Image" preview />
                            </figure>
                            <div className="content">
                              <p>Jul 10 at 10:00 am</p>
                              <span className="attachment-agent-name">RK</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                  </form>
                </div>
              ) : null,
            )}
        </div>
      );
    };
    return (
      <>
        {getModalLayout !== 2 && (
          <div id="popupSidebar" className="popup-sidebar hide-in-sidebar">
            {/* {!isSubtask && (
              <h5>
                <i className="ri-git-merge-line"></i> Subtasks
              </h5>
            )} */}
            <ul className="nav mt-2">
              <li>
                <span className={getStatusIcon(task_status)} style={{ marginRight: 8 }}></span>
                <button
                  className={`nav-link ${activeTab === "task" ? "active" : ""}`}
                  onClick={() => {
                    setActiveTab("task");
                    setActiveSubtaskId(null);
                  }}
                >
                  {title}
                </button>
              </li>

              {!isSubtask &&
                sub_tasks.map((eachSubtask) => (
                  <li key={eachSubtask.id} className="sub-task-item">
                    <span className={getStatusIcon(eachSubtask.task_status)} style={{ marginRight: 8 }}></span>
                    <button
                      className={`nav-link ${activeTab === "subtask" && activeSubtaskId === eachSubtask.id ? "active" : ""}`}
                      onClick={() => {
                        setActivityTab(1);
                        setActiveTab("subtask");
                        setActiveSubtaskId(eachSubtask.id);
                      }}
                    >
                      {eachSubtask.title}
                    </button>
                  </li>
                ))}
              {/* <li>
                <span className={getStatusIcon(task_status)} style={{ marginRight: 8 }}></span>
                <button className="nav-link active" id="task-data-tab" data-bs-toggle="pill" data-bs-target="#task-data" type="button" role="tab">
                  {title}
                </button>
              </li>
              {!isSubtask &&
                sub_tasks.map((eachSubtask, index) => (
                  <li className="sub-task-item">
                    <span className={getStatusIcon(eachSubtask.task_status)} style={{ marginRight: 8 }}></span>
                    <button className="nav-link" id={`subtask-tab-${eachSubtask.id}`} data-bs-toggle="pill" data-bs-target={`#subtask-${eachSubtask.id}`} type="button" role="tab">
                      {eachSubtask.title}
                    </button>
                  </li>
                ))} */}
              {!isSubtask && (
                <>
                  {showSubtaskFormFor === item.id ? (
                    <li className="subtaskAddInput" key={`subtask-input-${item.id}`}>
                      <input
                        ref={subtaskInputRef}
                        type="text"
                        className="form-control"
                        placeholder="Enter subtask title..."
                        value={modalSubtaskDetails.title || ""}
                        onChange={(e) => setModalSubtaskDetails({ title: e.target.value })}
                        onKeyDown={(e) => {
                          if (e.key === "Enter") {
                            e.preventDefault();
                            handleModalSubtaskSave(item);
                          } else if (e.key === "Escape") {
                            // allow escape to cancel quickly
                            setShowSubtaskFormFor(null);
                            setModalSubtaskDetails({ title: "" });
                          }
                        }}
                        onBlur={() => {
                          // if user clicked Cancel, avoid saving (click triggers blur first)
                          if (isCancellingRef.current) {
                            isCancellingRef.current = false;
                            return;
                          }
                          // auto-save on blur
                          handleModalSubtaskSave(item);
                        }}
                      />

                      <button
                        type="button"
                        className="btn"
                        title="Cancel"
                        onMouseDown={() => {
                          // mark cancelling so blur does not trigger a save
                          isCancellingRef.current = true;
                        }}
                        onClick={() => {
                          // hide input and clear
                          setShowSubtaskFormFor(null);
                          setModalSubtaskDetails({ title: "" });
                          // reset cancelling flag after click completes
                          setTimeout(() => (isCancellingRef.current = false), 0);
                        }}
                      >
                        <i className="ri-close-line" />
                      </button>
                    </li>
                  ) : (
                    <li className="add-subtask-btn">
                      <button className="nav-link" onClick={() => setShowSubtaskFormFor(item.id)}>
                        <i className="ri-add-line"></i> Add Subtask
                      </button>
                    </li>
                  )}
                </>
              )}
            </ul>
          </div>
        )}
        <div id="popupContentGrid" className="popup-content-grid">
          {getModalLayout !== 2 && (
            <div className={`popup-center-content hide-in-sidebar ${activityTab !== null ? "activity-tab-small" : "activity-tab-large"} activity-tab-${activityTab}`}>{renderTaskDetailLayout()}</div>
          )}
          <div id="activitySidebar" className={`activity-bar activity-bar-small ${activityTab !== null ? "active" : ""} activity-tab-${activityTab}`}>
            {activityTab === 0 && getModalLayout === 2 && <div className="popup-center-content">{renderTaskDetailLayout()}</div>}
            {activityTab === 1 && (
              <>
                <h4>
                  Activity{" "}
                  {getModalLayout !== 2 && (
                    <button
                      onClick={() => {
                        setActivityTab(null);
                      }}
                      className="btn activity-bar-close-btn"
                    >
                      <i className="ri-arrow-right-double-fill"></i>
                    </button>
                  )}
                </h4>
                <div className="activity-bar-content">
                  <ul className="history-list">
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                    <li className="mb-2">
                      Lead due date changed recently Lead due date changed recently <span>Jul 16 at 6:59 pm</span>
                    </li>
                  </ul>
                </div>
              </>
            )}
            {activityTab === 2 && (
              <>
                <h4>
                  Email{" "}
                  {getModalLayout !== 2 && (
                    <button
                      onClick={() => {
                        setActivityTab(null);
                      }}
                      className="btn activity-bar-close-btn"
                    >
                      <i className="ri-arrow-right-double-fill"></i>
                    </button>
                  )}
                </h4>
                <div className="activity-bar-content">
                  <div className={`smallEditor ${activeEditor ? "active" : ""}`}>
                    <div className="editor-wrapper">
                      <Editor
                        modules={customModules}
                        className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                        value={text}
                        placeholder="Enter your text here"
                        onFocus={() => setActiveEditor(true)}
                        // onBlur={() => setActiveEditor(false)}
                        onTextChange={(e) => setText(e.htmlValue)}
                      />

                      {activeEditor === true && (
                        <div className="editor-actions">
                          <button type="button" className="btn btn-sm ">
                            <i className="ri-check-line"></i>
                          </button>
                          <button type="button" className="btn btn-sm " onClick={() => setActiveEditor(false)}>
                            <i className="ri-close-line"></i>
                          </button>
                        </div>
                      )}
                    </div>
                    {/* <Editor
                      value={text}
                      placeholder="Enter your text here"
                      onFocus={() => setActiveEditor(true)}
                      onBlur={() => setActiveEditor(false)}
                      onTextChange={(e) => setText(e.htmlValue)}
                      modules={customModules}
                      className="texteditor"
                    />
                    <button type="button" className="submit-btn">
                      Send
                    </button> */}
                  </div>
                </div>
              </>
            )}
            {activityTab === 3 && (
              <h4>
                Links{" "}
                {getModalLayout !== 2 && (
                  <button
                    onClick={() => {
                      setActivityTab(null);
                    }}
                    className="btn activity-bar-close-btn"
                  >
                    <i className="ri-arrow-right-double-fill"></i>
                  </button>
                )}
              </h4>
            )}
            {activityTab === 4 && (
              <>
                <h4>
                  Notes{" "}
                  {getModalLayout !== 2 && (
                    <button
                      onClick={() => {
                        setActivityTab(null);
                      }}
                      className="btn activity-bar-close-btn"
                    >
                      <i className="ri-arrow-right-double-fill"></i>
                    </button>
                  )}
                </h4>
                <div className="activity-bar-content">
                  <div className={`smallEditor ${activeEditor ? "active" : ""}`}>
                    <div className="editor-wrapper">
                      <Editor
                        ref={editorRef}
                        modules={customModules}
                        className="texteditor editor-bottom-toolbar editor-bottom-toolbar"
                        value={text}
                        placeholder="Enter your text here"
                        onFocus={() => setActiveEditor(true)}
                        // onBlur={() => setActiveEditor(false)}
                        onTextChange={(e) => setText(e.htmlValue)}
                      />

                      {activeEditor === true && (
                        <div className="editor-actions">
                          <button type="button" className="btn btn-sm ">
                            <i className="ri-check-line"></i>
                          </button>
                          <button type="button" className="btn btn-sm " onClick={() => setActiveEditor(false)}>
                            <i className="ri-close-line"></i>
                          </button>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </>
            )}
            {activityTab === 5 && (
              <>
                <h4 className="document-header">
                  Documents
                  <div>
                    <button type="button" className="btn btn-small" title="Reset">
                      <i className="ri-refresh-line"></i>
                    </button>
                    <button className="btn btn-small">
                      <i class="ri-edit-2-line"></i>
                    </button>
                    <button className="btn btn-small">
                      <i className="ri-delete-bin-7-line"></i>
                    </button>
                    <button className="btn btn-small fs-18">
                      <i class="ri-add-line"></i>
                    </button>
                    {getModalLayout !== 2 && (
                      <button
                        onClick={() => {
                          setActivityTab(null);
                        }}
                        className="btn activity-bar-close-btn"
                      >
                        <i className="ri-arrow-right-double-fill"></i>
                      </button>
                    )}
                  </div>
                </h4>
                <div className="table-responsive edit-table">
                  <table className="table align-middle text-nowrap table-hover table-small">
                    <thead>
                      <tr>
                        <th style={{ width: "10px", paddingLeft: "10px", paddingRight: "0" }}>
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" />
                            <label className="form-check-label"></label>
                          </div>
                        </th>
                        <th>Name</th>
                        <th>Size</th>
                        <th>Description</th>
                        <th>Uplaoded by</th>
                        <th>Date added</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: "10px", padding: "5px 0 5px 10px" }}>
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <i class="ri-file-pdf-2-line"></i> &nbsp;
                          <a class="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                            customerbg.jpg
                          </a>
                        </td>
                        <td>125 kb</td>
                        <td>Document for real esate agents </td>
                        <td>Chandra</td>
                        <td>Jul 10 at 10:00 am</td>
                      </tr>
                      <tr>
                        <td style={{ width: "10px", padding: "5px 0 5px 10px" }}>
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <i class="ri-file-image-line"></i> &nbsp;
                          <a class="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                            customerbg.jpg
                          </a>
                        </td>
                        <td>125 kb</td>
                        <td>Seller agreements </td>
                        <td>Chandra</td>
                        <td>Jul 10 at 10:00 am</td>
                      </tr>
                      <tr>
                        <td style={{ width: "10px", padding: "5px 0 5px 10px" }}>
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <i class="ri-file-pdf-2-line"></i> &nbsp;
                          <a class="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                            customerbg.jpg
                          </a>
                        </td>
                        <td>125 kb</td>
                        <td>Buyer agreemnt signed document </td>
                        <td>Chandra</td>
                        <td>Jul 10 at 10:00 am</td>
                      </tr>
                      <tr>
                        <td style={{ width: "10px", padding: "5px 0 5px 10px" }}>
                          <div className="form-check">
                            <input type="checkbox" className="form-check-input" />
                            <label className="form-check-label"></label>
                          </div>
                        </td>
                        <td>
                          <i class="ri-file-image-line"></i> &nbsp;
                          <a class="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                            customerbg.jpg
                          </a>
                        </td>
                        <td>125 kb</td>
                        <td>Seller agreements </td>
                        <td>Chandra</td>
                        <td>Jul 10 at 10:00 am</td>
                      </tr>
                      {/* <tr>
                        <td>
                          <div class="d-flex align-items-center gap-2">
                            <div>
                              <Image src="./assets/images/agent-1.png" alt="Image" width="70" height="50" preview />
                            </div>
                            <div className="prop-title">
                              <a class="text-dark fw-medium fs-14" href="/property-details/324080861" data-discover="true">
                                customerbg.jpg
                              </a>
                            </div>
                          </div>
                        </td>
                        <td>Chandra</td>
                        <td>Jul 10 at 10:00 am</td>
                        <td>
                          <a href="" className="ri-delete-bin-7-line"></a>
                        </td>
                      </tr> */}
                    </tbody>
                  </table>
                </div>
                {/* <div className="activity-bar-content">
                  <div className="attachment-gallery">
                    <div className="attachment-gallery-item">
                      <figure>
                        <Image src="./assets/images/customer-bg.jpg" alt="Image" preview />
                      </figure>
                      <div className="content">
                        <p>Jul 10 at 10:00 am</p>
                        <span className="attachment-agent-name">RK</span>
                      </div>
                    </div>
                    <div className="attachment-gallery-item">
                      <figure>
                        <Image src="./assets/images/agent-1.png" alt="Image" preview />
                      </figure>
                      <div className="content">
                        <p>Jul 10 at 10:00 am</p>
                        <span className="attachment-agent-name">RK</span>
                      </div>
                    </div>
                  </div>
                </div> */}
              </>
            )}
            {activeTab === "task" && activityTab === 6 && (
              <>
                <h4 className="m-0">
                  Subtasks{" "}
                  {getModalLayout !== 2 && (
                    <button
                      onClick={() => {
                        setActivityTab(null);
                      }}
                      className="btn activity-bar-close-btn"
                    >
                      <i className="ri-arrow-right-double-fill"></i>
                    </button>
                  )}
                </h4>
                <div className="table-responsive edit-table">
                  <table className="table align-middle text-nowrap table-hover table-small">
                    <thead>
                      <tr>
                        <th>Name</th>
                        <th>Assignee</th>
                        <th>Due Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {sub_tasks.map((eachSubtask, index) => (
                        <tr>
                          <td>{eachSubtask.title}</td>
                          <td>Chandra</td>
                          <td>{formatDateTimeNew(eachSubtask.dueDate)}</td>
                          <td>
                            <a href="" className="ri-delete-bin-7-line"></a>
                          </td>
                        </tr>
                      ))}
                      <tr>
                        <td colSpan={4}>
                          <i className="ri-add-line"></i> Add Task
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="activity-bar-ribbon">
          <div className="activity-list">
            {getModalLayout === 2 && (
              <button
                onClick={() => {
                  setActivityTab(0);
                }}
                className={activityTab === 0 ? "activityInfo-button active" : "activityInfo-button"}
              >
                <i className="ri-align-left"></i>
                <span>Details</span>
              </button>
            )}
            <button
              onClick={() => {
                setActivityTab(1);
              }}
              className={activityTab === 1 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-chat-4-line"></i>
              <span>Activity</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(2);
              }}
              className={activityTab === 2 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-mail-line"></i>
              <span>Email</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(3);
              }}
              className={activityTab === 3 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-attachment-2"></i>
              <span>Links</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(4);
              }}
              className={activityTab === 4 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i className="ri-add-line"></i>
              <span>Notes</span>
            </button>
            <button
              onClick={() => {
                setActivityTab(5);
              }}
              className={activityTab === 5 ? "activityInfo-button active" : "activityInfo-button"}
            >
              <i class="ri-file-pdf-line"></i>
              <span>Docs</span>
            </button>
            {activeTab === "task" && (
              <button onClick={() => setActivityTab(6)} className={activityTab === 6 ? "activityInfo-button active" : "activityInfo-button"}>
                <i className="ri-git-merge-line"></i>
                <span>Subtasks</span>
              </button>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <div className="page-content tasks-page">
      <div className="container-fluid">
        <div className="row">
          <div className="col-12">
            <div className="task-page-header">
              <div className="task-page-header-left">
                <button
                  type="button"
                  className={taskView === "List" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("List");
                  }}
                >
                  <i className="ri-list-check"></i>
                  List
                </button>
                <button
                  type="button"
                  className={taskView === "Board" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("Board");
                  }}
                >
                  <i className="ri-dashboard-line"></i>
                  Board
                </button>
                {/* <button
                  type="button"
                  className={taskView === "Calendar" ? "btn active" : "btn"}
                  onClick={() => {
                    setTaskView("Calendar");
                  }}
                >
                  <i className="ri-calendar-2-line"></i>
                  Calendar
                </button> */}
              </div>
              <div className="task-page-header-right"></div>
            </div>
          </div>
        </div>
        {taskView === "List" && (
          <TaskList
            taskList={taskList}
            refreshTasks={refreshTasks}
            modifiedTaskDetails={modifiedTaskDetails}
            setModifiedTaskDetails={setModifiedTaskDetails}
            onClickTaskDetail={onClickTaskDetail}
            userList={userList}
          />
        )}
        {taskView === "Board" && taskList?.statusList && (
          <TaskBoards taskList={taskList} refreshTasks={refreshTasks} modifiedTaskDetails={modifiedTaskDetails} setModifiedTaskDetails={setModifiedTaskDetails} onClickTaskDetail={onClickTaskDetail} />
        )}
        {/* {taskView === "Calendar" && (
          <div className="calendar-view">
            <EventCalendar events={events} taskList={taskList} />
          </div>
        )} */}
      </div>

      <div className="minimize-grid">
        {viewTask.length >= 1 &&
          viewTask.map((item) => (
            <CustomModal
              key={item.id}
              renderItem={() => renderTaskDetails(item)}
              title={"Task Overview"}
              secondaryTitle={item.title}
              visible={true}
              showLeftSidebarIcon={true}
              showCreateDate={true}
              showMoreIcon={true}
              createdDate={formatDateTimeNew(item.created_at)}
              showLayoutIcon={viewTask.length === 1}
              getModalLayout={setGetModalLayout}
              onHandleClose={() => {
                const modifiedData = viewTask.filter((task) => task.id !== item.id);
                setViewTask(modifiedData);
                setActivityTab(null);
              }}
            />
          ))}
      </div>
    </div>
  );
};

export default Tasks;
